import { useState, useEffect } from 'react';

function LoadingComponent() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const newProgress = oldProgress + 1;
        return newProgress >= 100 ? 100 : newProgress;
      });
    }, 20);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full">
      {/* Progress bar container */}
      <div className="w-full h-1 bg-gray-200">
        {/* Animated progress bar */}
        <div
          className="h-full bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      {/* Progress percentage */}
      <div className="absolute right-4 top-2 text-sm font-medium text-white">
        {progress}%
      </div>
    </div>
  );
}

export default LoadingComponent;
